import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  MEDIUM_DEVICE_MQ,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const savebarClassName = css({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  width: '100%',
  zIndex: 9999,
});

export const innerClassName = css({
  alignItems: 'center',
  background: '#1A1B1D',
  borderBottom: '1px solid #EBEBEB',
  display: 'flex',
  height: 68,
});

export const headerClassName = css({
  maxWidth: 250,
  padding: `0px ${Spacing.LG}px`,
  width: '100%',
});

export const bodyClassName = css({
  width: '100%',
});

export const containerClassName = css({
  margin: 'auto',
  maxWidth: 1120,
  paddingLeft: 'var(--bs-gutter-x)',
  paddingRight: 'var(--bs-gutter-x)',
  [MEDIUM_DEVICE_MQ]: {
    paddingLeft: Spacing.XL,
    paddingRight: Spacing.XL,
  },
});

export const wrapperClassName = css({
  alignItems: 'center',
  display: 'flex',
});

export const actionClassName = css({
  alignItems: 'center',
  display: 'flex',
  marginLeft: 'auto',
});

export const btnPrimaryClassName = css({
  background: Colors.Brand,
  border: `1px solid ${Colors.Brand}`,
  color: Colors.White,
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.SEMI_BOLD,
  minHeight: 40,
  minWidth: 80,
  padding: `${Spacing.XS}px 18px`,
  '&:hover': {
    background: Colors.BrandHover,
    borderColor: Colors.BrandHover,
  },
  [SMALL_DEVICE_MQ]: {
    fontWeight: FontWeight.MEDIUM,
  },
});

export const btnPrimaryDisabledClassName = css({
  background: Colors.Brand,
  borderColor: Colors.Brand,
});

export const btnSecondaryClassName = css({
  background: 'transparent',
  border: '1px solid #999',
  color: '#E3E5E7',
  fontSize: FontSize.COMPACT,
  fontWeight: FontWeight.SEMI_BOLD,
  marginRight: Spacing.XS,
  minHeight: 40,
  padding: `${Spacing.XS}px 18px`,
  '&.disabled, &:hover': {
    background: '#3D3F42',
    color: Colors.White,
  },
  [SMALL_DEVICE_MQ]: {
    fontWeight: FontWeight.MEDIUM,
  },
});

export const btnSecondaryDisabledClassName = css({
  background: '#3D3F42',
  color: Colors.White,
});
